<template>
  <el-table
    :data="quotes"
    stripe
  >
    <el-table-column
      prop="carrier_name"
      label="Carrier"
      sortable
    >
      <template #default="scope">
        <span>
          {{ scope.row.carrier_name }}
        </span>
        <span>
          {{ services.filter(s => s.code === scope.row.service_code)[0] ? ' - ' + services.filter(s => s.code === scope.row.service_code)[0].name : '' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="service_name"
      label="Service"
      sortable
    />
    <el-table-column
      prop="est_cost_ex"
      label="Freight"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? '$' +cellValue : '-'"
    />
    <el-table-column
      prop="est_cost_fuel"
      label="Fuel"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? '$' +cellValue : '-'"
    />
    <el-table-column
      prop="est_cost_fees"
      label="Fees"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? '$' +cellValue : '-'"
    />
    <el-table-column
      prop="totalCostEx"
      label="Cost (ex)"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? '$' +cellValue : '-'"
    />
    <el-table-column
      prop="est_cost_tax"
      label="Tax"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? '$' +cellValue : '-'"
    />
    <el-table-column
      label="Cost (inc)"
      sortable
    >
      <template #default="scope">
        <span>
          {{ scope.row.est_cost_ex || 0 + scope.row.est_cost_fuel || 0 + scope.row.est_cost_fees || 0 + scope.row.est_cost_tax || 0 ? '$' + (scope.row.est_cost_ex || 0 + scope.row.est_cost_fuel || 0 + scope.row.est_cost_fees || 0 + scope.row.est_cost_tax || 0) : '-' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="est_cost_fees_desc"
      label="Fee Description"
      sortable
    />
    <el-table-column
      prop="est_ett"
      label="ETT"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? cellValue : 'N/A'"
    />
    <el-table-column
      prop="est_etd"
      label="ETD"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? cellValue : 'N/A'"
    />
    <el-table-column
      prop="source"
      label="Source"
    />
  </el-table>
</template>
<script>
export default {
  props: {
    quotes: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      required: false,
      default: Array
    }
  },
  computed: {
    totalCostEx () {
      return this.quotes.reduce((acc, quote) => acc + quote.est_cost_ex + quote.est_cost_fuel + quote.est_cost_fees, 0)
    },
    totalCostInc () {
      return this.quotes.reduce((acc, quote) => acc + quote.est_cost_ex + quote.est_cost_fuel + quote.est_cost_fees + quote.est_cost_tax, 0)
    }
  }
}
</script>
